export const HAKLAI_PROPERTY_PART_LABELS = Object.freeze({
  sectionTitle: "מרכיבי הנכס",
  emptySection: "לא נוספו רכיבים בחלקה זו",
  assetType: "סוג נכס",
  farmAssets: "נכסי המשק",
  relativeSaleValue: "שווי יחסי מהמכירה",
  remainingToAllocate: "יתרה לחלוקה",
  builtValue: "שווי החלק הבנוי",
  zabanValue: 'שווי זב"ן',
  rentalDepreciation: "האם הושכר?",
  sectionA: "חלקה א׳",
  sectionBg: "חלקה ב+ג",
  residential: "מגורים",
  commercial: "נכס מסחרי",
  landAndShared: "קרקע ומשותף",
  selectAssetType: "בחר סוג",
  saleValuePlaceholder: "הזן סכום",
  builtValuePlaceholder: "הזן שווי בנוי",
  notRelevantInSection: "לא רלוונטי בסעיף זה",
  notRelevantWithoutZaban: 'לא רלוונטי ללא זב"ן',
  zabanNotSelected: 'זב"ן לא סומן במשק',
  pre1997ConstructionQuestion: "הבנייה הסתיימה לפני 1.4.1997?",
  singleApartmentExemption: "פטור דירה יחידה",
  singleApartmentExemptionBadge: "פטור דירה יחידה",
  inheritanceExemptionBadge: "פטור ירושה",
  inheritanceExemption: "פטור ירושה"
});

export const HAKLAI_PROPERTY_PART_TOOLTIPS = Object.freeze({
  autoCalculated: "מחושב אוטומטית",
  autoCalculatedWhenZabanSelected: 'מחושב אוטומטית כאשר זב"ן מסומן במשק',
  deletePart: "מחיקת רכיב נכס",
  rentalDepreciationForPart: "פחת בשכירות לרכיב הנכס"
});

export const HAKLAI_PROPERTY_PART_ERRORS = Object.freeze({
  missingAnyPart: "יש להזין לפחות חלק אחד בנכס",
  missingPrimaryResidenceValue: "יש להזין שווי לבית המגורים הראשי",
  missingPartValue: "יש להזין שווי לכל חלק",
  missingAddedPartName: "יש להזין שם לחלק שנוסף",
  missingRelevantBuiltValue: "יש להזין את שווי החלק הבנוי לכל חלק מגורים רלוונטי",
  invalidRelevantBuiltValue: "יש להזין שווי חלק בנוי תקין לכל חלק מגורים",
  builtValueGreaterThanPartValue: "שווי החלק הבנוי לא יכול להיות גדול משווי החלק",
  saleValueTotalMismatch: "סכום שוויי החלקים חייב להיות שווה לשווי המכירה",
  remainingValue: "שווי החלקים נמוך משווי המכירה",
  valueOvershoot: "שווי זה חורג מסך שווי המכירה",
  builtValueExceedsPartValue: "שווי החלק הבנוי גבוה משווי החלק",
  required: "שדה חובה"
});

export const getHaklaiPropertyPartAddAriaLabel = (sectionTitle, canAdd) => (
  canAdd
    ? `הוסף רכיב ל${sectionTitle}`
    : `לא ניתן להוסיף רכיב נוסף ל${sectionTitle}`
);
